import { useContext, useState } from "react";
import { NavPage } from "../../services/NavService";
import "../../style/editor.scss";
import { EditorNav } from "../EditorNav/EditorNav";
import { TopNav } from "../TopNav/TopNav";
import { InteriorImage } from "./InteriorImage";
import { InteriorDragContext, InteriorDragContextInfo } from "./InteriorImageDragContext";
import { InteriorItemEditor } from "./InteriorItemEditor";
import { ProductList } from "./ProductList";
import "./InteriorEditor.scss";
import { EditorContext } from "../EditorCommon/EditorContext";
import { InteriorMaterialSelector } from "./InteriorMaterialSelector";



export function InteriorEditor() {

    const [currentDragInfo, setCurrentDragInfo]
        = useState(undefined as (InteriorDragContextInfo | undefined));

    const ec = useContext(EditorContext);

    function updateCurrentItem(info: InteriorDragContextInfo | undefined): InteriorDragContextInfo | undefined {
        if (!info)
            return;
        if (!info.item)
            return info;
        const newItem = ec.cabinet.interiorItems.find(ii => ii.index === info.item?.index);
        return {
            ...info,
            item: newItem ?? info.item
        };
    }

    return (
        <div className="editor ext-editor interior-editor">
            <TopNav header={ec.translator("interiorEditor header", "Interiør")} />
            <InteriorDragContext.Provider value={{
                info: updateCurrentItem(currentDragInfo),
                setInfo: info => {
                    setCurrentDragInfo(info);
                }
            }} >
                <div className="left-toolbox">
                    <InteriorMaterialSelector />
                    <ProductList />
                </div>

                <InteriorImage className="main-editor" displayHelpTextOnEmpty={true} />

                <div className="right-toolbox">
                    <InteriorItemEditor />
                </div>
            </InteriorDragContext.Provider>

            <EditorNav currentPage={NavPage.Interior} />
        </div>
    );
}

